import * as React from "react";
import { Grid } from "@material-ui/core";
import TextEditor from "../../Editor";
import { convertToEditor } from "../../../utils/helper";
import { bucketURL, showEditIconBlue } from "../../../server/constants";


function LearnEnrollment(props: any) {
  const {
    iliaTitle,
    iliaDesc,
    iliaStrategyList,
    handWithIpad
  } = props;

  return (
    <div className="sectionPD pb0">
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12} md={6}>

          <TextEditor align="left" className="title"
                      sectionId={"iliaTitle"}
                      content={iliaTitle}
                      upperDivClass={showEditIconBlue}
          />


          <TextEditor align="left"
                      sectionId={"iliaDesc"}
                      content={iliaDesc}
                      upperDivClass={showEditIconBlue}/>

          <TextEditor
            sectionId={"iliaStrategyList"}
            content={iliaStrategyList}
            upperDivClass={showEditIconBlue}
          />

        </Grid>
        <Grid item xs={12} md={6}>
          <TextEditor content={convertToEditor("Image")}
                      src={`${bucketURL}/${handWithIpad}`} sectionId={"handWithIpad"}
                      className="w100 positionR h100"
                      upperDivClass={showEditIconBlue}/>
        </Grid>
      </Grid>
    </div>
  )
}

export default LearnEnrollment;
